<template>
  <div class="container">
    <iframe :src="pdfUrl" width="100%" height="100%"></iframe>
  </div>
</template>



<script  setup >
import { ref, onMounted,defineProps } from 'vue';
const fileUrlNew = '/pdfjs-4.10.38-dist/web/viewer.html?file='; // pdfjs自带文件地址 新浏览器
const fileUrlOld = '/pdfjs-4.10.38-legacy-dist/web/viewer.html?file='; // pdfjs自带文件地址 老浏览器
const pdfUrl = ref("")

const props = defineProps({
  pdfurl: {
    // default: "https://cdn.memscloud.cn/competition/work/3/%E7%B3%BB%E7%BB%9F%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88%E4%BA%8B%E4%B8%9A%E9%83%A8-%E9%A1%B9%E7%9B%AE%E7%AE%A1%E7%90%86%E5%B9%B3%E5%8F%B0-%E4%BD%BF%E7%94%A8%E6%89%8B%E5%86%8C.pdf?e=1736912428&token=2OT4bQJAVqfhVxcd2DxZnjKjDY44a7yZnOYeZAiV:XzfWjczMTF3H-7wNa13WR6PJDzw=", // pdf链接
    //  default:"https://raw.githubusercontent.com/mozilla/pdf.js/ba2edeae/web/compressed.tracemonkey-pldi-09.pdf"
    default:""
  }
})
onMounted(()=>{
  let fileUrl = fileUrlNew
  if(typeof Promise !== 'undefined' &&
      typeof fetch !== 'undefined' &&
      'assign' in Object &&
      'includes' in Array.prototype){ //

    fileUrl = fileUrlNew
  }else{
    fileUrl = fileUrlOld
  }
  // pdfUrl.value = fileUrl + encodeURIComponent(props.pdfurl); // 使用pdf.js内嵌
  pdfUrl.value = props.pdfurl // 直接浏览器内嵌
})

</script>

<style scoped>
.container {
  width: 100%;
  height: 100%;
}
</style>
